<template>
    <TxProductSettingsPortal>
        <TxSettingsUi>
            <div title="1. Välj utseende">
                <div>
                    <LoveMapToggle
                            v-model="mapSize"
                            label="Välj storlek"
                            :options="sizeOptions"
                    />
                </div>
                <div>
                    <LoveMapToggle
                            v-model="mapLayout"
                            label="Format"
                            :options="layoutOptions"
                    />
                </div>
                <!--                <div>-->
                <!--                    <LoveMapToggle-->
                <!--                            v-model="mapStyle"-->
                <!--                            label="Map Style"-->
                <!--                            :options="mapStyles"-->
                <!--                    />-->
                <!--                </div>-->
            </div>
            <div title="2. Välj städer">

                <label class="stad-label">Välj stad</label>
                <stf-select class="coordinates-input" v-model="selected1">
                    <div slot="label">Fyll i din stad här</div>
                    <div slot="value">
                        <div v-if="selected1">
                            <span>{{enableGeoAPI ? selected1.formatted_address : selected1.display_name}}</span>
                        </div>
                    </div>
                    <div slot="search-input">
                        <input @input="fetchOptions" @keydown.enter.prevent.stop>
                    </div>
                    <section class="options delivery_order__options">
                        <stf-select-option
                                v-for="item of cityOptions1" :key="item.place_id"
                                :value="item"
                                :class="{'stf-select-option_selected': item.place_id === (selected1 && selected1.place_id)}"
                        >
                            <span>{{enableGeoAPI ? item.formatted_address : item.display_name}}</span>
                        </stf-select-option>
                    </section>
                </stf-select>

                <love-map-input
                        v-model="city"
                        placeholder="Fyll i din stad här"
                        label="Rubrik"
                />
                <love-map-input
                        v-model="country"
                        placeholder="Fyll i din stad här"
                        label="Land, landskap etc"
                />
            </div>
            <div title="3. Ram" v-if="$root.env === 'frontend'">
                <love-map-select v-model="selectedRam" label="Ram" :options="ramOptions"/>
            </div>
        </TxSettingsUi>
        <love-map-description>
            Glöm inte dubbelkolla så att din Stadskarta ser ut som du vill ha den, den går inte att ändra i efterhand.
        </love-map-description>
    </TxProductSettingsPortal>
</template>

<script>
    import debounce from 'lodash/debounce'

    import mapPresets from "./data/mapPresets";

    import ramMapping from "./data/ramMapping.json"
    import CityMapModule from "@packages/tx-products/products/city-map/store-mixin";
    import useSaveUrlMixin from "@packages/tx-mixins/mixins/saveUrl.mixin"

    import templateOptions from "./data/templateOptions";

    export default {
        name: 'CityMapSettings',
        mixins: [CityMapModule(), useSaveUrlMixin('city-map')],
        watch: {
            selected1(newValue, oldValue) {
                if (this.enableGeoAPI) {
                    console.log(newValue);
                    let {geometry} = newValue;

                    let country = newValue?.address_components.find(item => !item.types.indexOf('country'));
                    let city = newValue?.address_components.find(item => !item.types.indexOf('locality'));
                    console.log(country);
                    console.log(city);

                    let {location} = geometry;

                    if (country?.long_name) {
                        this.country = country?.long_name
                    }
                    if (city?.long_name) {
                        this.city = city?.long_name
                    }
                    this.center = [location.lat, location.lng]
                } else {
                    this.center = [newValue.lat, newValue.lon]
                }
                this.firstCityData = newValue
            },
          mapSize:{
            handler: function (newValue, oldValue) {
              this.mapSizeChanged(newValue);
              this.initRamField(newValue)
            },
            immediate: true
          },
            selectedRam(newValue, oldValue) {
                this.ramChanged(newValue);
            },
        },
        data() {
            return {
                isTitleChanged: false,
                ramOptions: [],
                preset: null,
                selectedRam: null,
                selected1: null,
                cityOptions1: [],
                ...templateOptions,
            }
        },
        created() {
            this.$on('onTemplateDataUrl', this.onTemplateDataUrl)
        },
        mounted() {
            this.$nextTick(() => {
                if (!this.mapSize) {
                    this.mapSize = 'a4';
                }

                setTimeout(() => {
                    this.initRamField();
                }, 2000)
            })
        },
        computed: {
            geoAPI() {
                return lovemap?.config?.geoAPI
            },
            enableGeoAPI() {
                return !!this.geoAPI
            },
            searchUrl() {
                if (this.enableGeoAPI) {
                    return 'https://maps.googleapis.com/maps/api/geocode/json'
                } else {
                    return 'https://nominatim.openstreetmap.org/search'
                }
            },
        },
        methods: {
            onTemplateDataUrl(isLoading) {
                if (this.$root.env === 'frontend') {
                    if (!isLoading) {
                        this.preset = 'sverige';
                        this.setPreset('sverige');
                        this.geoFindMe();
                    } else {

                    }
                }
            },
            async geoFindMe() {
                if (!navigator.geolocation) {
                    // status.textContent = 'Geolocation is not supported by your browser';
                } else {
                    // status.textContent = 'Locating…';
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            console.log(position);
                            const latitude = position.coords.latitude;
                            const longitude = position.coords.longitude;
                            this.center = [latitude, longitude];
                            this.searchLocation([latitude, longitude], this)
                        },
                        () => {
                            // status.textContent = 'Unable to retrieve your location';
                        }
                    );
                }
            },
            getRamSelector() {
                let {fieldSelector} = ramMapping[this.mapSize]
                return fieldSelector
            },
            initRamField(value) {
                let fieldSelector = this.getRamSelector();
                console.log(fieldSelector);
                jQuery(".variations_form.cart").arrive(fieldSelector, () => {
                    this.$set(this, 'ramOptions', this.getSelectArray(fieldSelector))
                    this.selectedRam = 'ingen_ram';
                });
            },
            getSelectArray(selector) {
                if (selector) {
                    let array = [];
                    jQuery(selector).find('option').each(function (i, o) {
                        let item = {};
                        item.label = jQuery(o).text();
                        item.value = jQuery(o).val();
                        array.push(item);
                    });
                    return array
                }
                return [];
            },
            presetChanged(value) {
                this.setPreset(value);
            },
            setPreset(value) {
                this.presetSelected = true;
                this.$nextTick(() => {
                    let preset = mapPresets[value];
                    if (preset) {
                        Object.keys(preset).map(key => {
                            this.$set(this, key, preset[key]);
                        })
                    }
                    setTimeout(() => {
                        this.presetSelected = false;
                    }, 500)
                })

            },
            searchLocationObject([lat, lng]) {
                if (this.enableGeoAPI) {
                    return {
                        key: this.geoAPI,
                        latlng: `${lat},${lng}`,
                        language: 'sv'
                    }
                } else {
                    return false
                }
            },
            searchObject(search) {
                if (this.enableGeoAPI) {
                    return {
                        key: this.geoAPI,
                        address: search,
                        language: 'sv'
                    }
                } else {
                    return {
                        format: 'json',
                        city: search
                    }
                }
            },
            saveSearch(key, data) {
                if (this.enableGeoAPI) {
                    let {results, status} = data
                    if (status) {
                        this.$set(this, key, results);
                    }

                } else {
                    this.$set(this, key, data);
                }
            },
            onsearch(e) {
                if (e.target.value) {
                    this.listFinded = this.list.filter(el => el.text.indexOf(e.target.value) !== -1 || el.address.indexOf(e.target.value) !== -1);
                } else {
                    this.listFinded = this.list;
                }
            },
            fetchOptions(event) {
                this.search(event.target.value, this);
            },
            fetchOptions2(event) {
                this.search2(event.target.value, this);
            },
            searchLocation: debounce((location, vm) => {
                let http = vm.$root.env === 'admin' ? vm.$httpExternal : vm.$http;
                http({
                    method: 'get',
                    url: vm.searchUrl,
                    params: vm.searchLocationObject(location)
                }).then(({data}) => {
                    let {
                        results = []
                    } = data;

                    let address = results.find(result => {
                        return result?.types.find(item => !item.indexOf('administrative_area_level_1') || !item.indexOf('locality'))
                    });

                    let country = address?.address_components.find(item => !item.types.indexOf('country'))?.long_name;
                    let city = address?.address_components.find(item => !item.types.indexOf('locality'))?.long_name;

                    vm.country = country
                    vm.city = city
                });
            }, 350),
            search: debounce((search, vm) => {
                let http = vm.$root.env === 'admin' ? vm.$httpExternal : vm.$http;
                http({
                    method: 'get',
                    url: vm.searchUrl,
                    params: vm.searchObject(search)
                }).then(({data}) => {
                    vm.saveSearch('cityOptions1', data);
                });
            }, 350),
            search2: debounce((search, vm) => {
                let http = vm.$root.env === 'admin' ? vm.$httpExternal : vm.$http;
                http({
                    method: 'get',
                    url: vm.searchUrl,
                    params: vm.searchObject(search)
                }).then(({data}) => {
                    vm.saveSearch('cityOptions2', data);
                });
            }, 350),
            mapSizeChanged(value) {
                if (jQuery && jQuery('[name="attribute_pa_storlek"]').length) {
                    jQuery('[name="attribute_pa_storlek"]').val(value).change();
                }
            },
            ramChanged(value) {
                let selector = this.getRamSelector();
                console.log(selector)
                if (jQuery && jQuery(selector).length) {
                    jQuery(selector).val(value).change();
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .stad-label {
        margin-bottom: -5px;
    }

    ::v-deep .coordinates-input {
        width: 100%;
        margin: 0 auto 15px;
        height: 39px;

        & * {
            font-size: 0.875rem !important;
            font-weight: normal !important;
        }

        .stf-select__inner-wrapper {
            display: block;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            width: 100%;
            padding: 0 0.5rem;
            border: 1px solid rgba(41, 41, 41, 0.1);
            border-radius: 0;
            font-family: inherit;
            line-height: 1.5;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            color: #444;
            background-color: #fff;
            height: 2.5rem;
            outline: none;
            font-weight: 900;
            margin: 0;
        }

        .stf-select__search-input input {
            height: 39px;
        }

        .stf-select__placeholder {
            line-height: 39px;
            color: #cacaca;
        }

        &.stf-select_opened {
            .stf-select__inner-wrapper {
                border: none;
            }

            .stf-select__search-input input {
                outline-width: 0;
                color: #444;
                border: 1px solid rgba(41, 41, 41, 0.15) !important;
                background: #fafafa;
            }
        }
    }
</style>

<style lang="scss">
    #wccf_product_field_master_container {
        display: none;
    }

    table.variations {
        display: none;
    }
</style>

